<template>
  <v-container class="fill-height" style="display: block;" fluid>
    <v-window v-model="windowPage" style="width: 100%;" touchless>

        <v-window-item :key="0">
          <template v-if="showThresholdProfilesList">
            <threshold-profile-list :thresholdProfileList="thresholdProfileList" :lockSave="lockSave" @edit="editThresholdProfile" @delete="deleteThresholdProfileClick" @clone="cloneThresholdProfile"></threshold-profile-list>
            <v-btn color="#c42111" class="mt-3 mr-3" @click="addNewThresholdProfile" :disabled="lockSave">New</v-btn>
          </template>
        </v-window-item>

        <v-window-item :key="1">
            <threshold-profile-edit v-if="windowPage == 1" :thresholdProfile="selectedThresholdProfile" :thresholdResources="thresholdResources" :allSitesUsed="allSitesUsed" :lockSave="lockSave" @save="saveThresholdProfile" @cancel="onEditCancel"></threshold-profile-edit>
        </v-window-item>

    </v-window>
  </v-container>
</template>

<script>
import ThresholdProfileList from "@/components/ThresholdProfiles/ThresholdProfileList";
import ThresholdProfileEdit from "@/components/ThresholdProfiles/ThresholdProfileEdit";
export default {
    name: 'ThresholdProfiles',
    props: [''],
    components: {
        ThresholdProfileList,
        ThresholdProfileEdit,
    },
    data: () => ({
        windowPage: 0,
        lockSave: false,
        thresholdProfileList: [],
        showThresholdProfilesList: false,
        selectedThresholdProfile: null,
        thresholdResources: {
            conditions: ["equal to", "not equal to", "less than", "greater than","less than or equal to", "greater than or equal to"],
            severities: ["CRITICAL", "MAJOR", "MINOR", "OBSERVATIONAL"],
            allSitesList: {},
            reports: [],
        },
    }),

    computed: {
        allSitesUsed() {
            let result = [];
            for(let tp of this.thresholdProfileList) {
                result.push({
                    id: tp.tp_id,
                    sites: tp.selected_sites
                });
            }
            return result;
        }
    },

    methods: {
        getThresholdProfileList: function() {
            this.showThresholdProfilesList = false;
            let route = (TELSA.apiHost + "thresholdprofile/list");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.thresholdProfileList = result.data.threshold_profile_list;
                this.thresholdResources.reports = result.data.thresholds;
                this.thresholdResources.allSitesList = result.data.all_sites_list;
                this.showThresholdProfilesList = true;
                // Check report permissions
                for(let report of this.thresholdResources.reports) {
                    report.disabled = !TELSA.checkPermissionQualifier(this.$store.state.user, `reports/run`, report.name, !this.$store.state.batchConfig.product_perms);
                }
            });
        },

        deleteThresholdProfileClick: function(thresholdProfileId) {
            this.$store.commit('showConfirmModal', {
                title: 'Delete Threshold Profile',
                message: `Are you sure you want to delete this threshold profile?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteThresholdProfile(thresholdProfileId)
            });
        },

        deleteThresholdProfile: function(thresholdProfileId) {
            let route = (TELSA.apiHost + "thresholdprofile/delete");
            TELSA.loading(true);
            this.$http.post(route, {args: {lock: this.$store.state.lock, thresholdProfileId: thresholdProfileId}}).then(response => {
                let result = response.body;
                this.getThresholdProfileList().then(r => {TELSA.loading(false);})
            });
        },

        editThresholdProfile: function(thresholdProfile) {
            // Making this a clone so that it's not bound to the root list. This allows for "cancel" functionality.
            this.selectedThresholdProfile = JSON.parse(JSON.stringify(thresholdProfile));
            this.windowPage = 1;
            this.$store.commit('setIsDirty', false);
        },

        cloneThresholdProfile: function(thresholdProfile) {
            let thresholdProfileClone = JSON.parse(JSON.stringify(thresholdProfile));
            thresholdProfileClone.tp_id = 0;
            this.selectedThresholdProfile = thresholdProfileClone;
            this.windowPage = 1;
        },

        addNewThresholdProfile: function() {
            let newThresholdProfile = {
                thresholds: [],
                selected_sites: [],
                tp_id: 0,
                tp_name: ''
            };
            this.selectedThresholdProfile = newThresholdProfile;
            this.windowPage = 1;
        },

        saveThresholdProfile: function(thresholdProfile) {
            // fix potential issue with threshold profile selected sites
            thresholdProfile.selected_sites = [...new Set(thresholdProfile.selected_sites)];

            let route = (TELSA.apiHost + "thresholdprofile/edit");
            if(thresholdProfile.tp_id == 0) {
                route = (TELSA.apiHost + "thresholdprofile/add");
            }
            TELSA.loading(true);
            this.$http.post(route, {args: {lock: this.$store.state.lock, thresholdProfile: thresholdProfile}}).then(response => {
                let result = response.body;
                this.$store.commit('setIsDirty', false);
                this.windowPage = 0;
                this.getThresholdProfileList().then(r => {TELSA.loading(false);})
            });
        },

        onEditCancel: function() {
            if(this.$store.state.isDirty) {
                this.$store.commit('showConfirmModal', {
                    title: 'Are you sure?',
                    message: 'Are you sure you want to abandon your changes without saving?',
                    type: 'warning',
                    confirmAction: () => {this.$store.commit('setIsDirty', false); this.windowPage = 0;}
                });
            }
            else {
                this.windowPage = 0;
            }
        },
    },

    mounted() {
        // Permissions Check
        let permission = TELSA.checkPermission(this.$store.state.user, 'admin/report/threshold-profiles');
        if(!permission) {
            let self = this;
            this.$store.commit('insufficientPermissions', {
                confirmAction: function(){self.getThresholdProfileList().then(r => {TELSA.loading(false);})}
            });
            this.lockSave = true;
            return;
        }

        let promises = [];
        let lockName = `edit_thres`;
        let lockOwner = null;
        promises.push(this.$store.dispatch('getLock', lockName).then(l => {lockOwner = l}));
        promises.push(this.getThresholdProfileList());
        Promise.all(promises).then(v => {
            TELSA.loading(false);

            if(lockOwner) {
                // Disable save and let user know page is locked!
                this.lockSave = true;
                this.$store.commit('showConfirmModal', {
                    title: 'Lock Warning',
                    message: `Threshold profiles are already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot save any changes at this time.`,
                    type: 'warning',
                    hideCancel: true,
                    confirmAction: function(){}
                });
            }
        });
    }

  
};
</script>

<style scoped>

    .data-container {
        display: block;
        padding: 0;
    }

</style>
